import { render, staticRenderFns } from "./AdminWarehouse.vue?vue&type=template&id=5db9a7a6&scoped=true&"
import script from "./AdminWarehouse.vue?vue&type=script&lang=js&"
export * from "./AdminWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./AdminWarehouse.vue?vue&type=style&index=0&id=5db9a7a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db9a7a6",
  null
  
)

export default component.exports